import React, { Component } from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import { Redirect } from "react-router-dom";
import * as icons from "common/icons";
import Page from "components/Page";
import PageBody from "components/PageBody";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import TileBodyMessage from "components/TileBodyMessage";
import Alert from "components/Alert";
import ActionLink from "components/ActionLink";
import TileActionsBar from "components/TileActionsBar";
import FarmHomePageHead from "containers/FarmHome/FarmHomePageHead";
import FarmAccessList from "./FarmAccessList";
import PendingFarmAccessInvitations from "./PendingFarmAccessInvitations";
import { modal } from "containers/App/_actions";
import { fetchPublicationAccess } from "./_actions";
import * as utils from "common/utils";

class PublicationAccess extends Component {
    componentDidMount() {
        const { farm, fetchPublicationAccess } = this.props;
        fetchPublicationAccess(farm.id);
    }

    _addPublicationAgent = (accessInvitation) => (e) => {
        if (!accessInvitation) accessInvitation = {};

        const viewModel = {
            ...accessInvitation,
            farmId: this.props.farm.id,
        };
        this.props.modal("GrantPublicationAccessModal", null, viewModel);
    };

    render() {
        const { online, isLoading, farm = {}, authContext, refData } = this.props;
        const { access = [], accessInvitations = [] } = farm;
        const { publications = [] } = farm;
        const hasPublications = publications.length > 0;
        const referrer = `/app/farm/${farm.id}`;
        const canGrantAgentAccess = utils.canGrantPublicationAccess(farm);

        if ((!authContext.isSystemAdmin && !canGrantAgentAccess) || !hasPublications) {
            return <Redirect push to={{ pathname: referrer }} />;
        }

        const pendingAccessInvitations = accessInvitations.filter((a) => a.status === "Pending");
        const isStudent = authContext.accountType === "Student";

        const breadcrumb = [{ name: farm.name, to: referrer }, { name: "Manage publication access" }];

        return (
            <Page>
                <FarmHomePageHead farm={farm} authContext={authContext} refData={refData} breadcrumb={breadcrumb} />
                <PageBody>
                    <Panel title="Manage publication access" referrer={referrer}>
                        <Alert
                            type="help"
                            text={
                                <span>
                                    Use this screen to manage the <b>users</b> who can act as your agent for all publications that have been published to you for this farm.
                                </span>
                            }
                        />
                        <PanelBody>
                            {online && !isStudent && (
                                <TileActionsBar>
                                    <ul className="ActionsBar-links">
                                        <li>
                                            <ActionLink className="IconLink--arrow-plus" id="add-access-action" onClick={this._addPublicationAgent()}>
                                                Grant publication access
                                            </ActionLink>
                                        </li>
                                    </ul>
                                </TileActionsBar>
                            )}
                            {pendingAccessInvitations.length > 0 && <PendingFarmAccessInvitations online={online} farm={farm} pendingAccessInvitations={pendingAccessInvitations} resend={this._addPublicationAgent} isPublicationAccess={true} />}
                            {access && access.length > 0 && <FarmAccessList online={online} access={access} farm={farm} authContext={authContext} isPublicationAccess={true} />}
                            {access && access.length === 0 && !isLoading && (
                                <Panel title="Users with publication access" midBlue>
                                    <PanelBody>
                                        <TileBodyMessage>
                                            <img src={icons.add} alt="Plus" />
                                            <p className="lead">You have not granted any users publication access for this farm</p>
                                            {online && !isStudent && (
                                                <ActionLink className="IconLink--arrow-plus Button Button--lg u-mt-lg" id="add-access-link" onClick={this._addPublicationAgent()}>
                                                    Grant access
                                                </ActionLink>
                                            )}
                                        </TileBodyMessage>
                                    </PanelBody>
                                </Panel>
                            )}
                        </PanelBody>
                    </Panel>
                </PageBody>
            </Page>
        );
    }
}

export default compose(withAppContext, withActions({ modal, fetchPublicationAccess }))(PublicationAccess);
